export const IPOOTPREGISTER_DATA = "IPOMASTERBANK_DATA";
export const IPOOTPREGISTER_ERROR_DATA = "IPOMASTERBANK_ERROR_DATA";
export const IPOOTPREGISTER_HIDE_ERROR_DATA = "IPOMASTERBANK_HIDE_ERROR_DATA";
export const IPOOTPREGISTER_START_LOADER = "IPOMASTERBANK_START_LOADER";
export const IPOOTPREGISTER_STOP_LOADER = "IPOMASTERBANK_STOP_LOADER";
